export default __webpack_public_path__ + "static/media/retro_noimage.6d38d08b.jpg";